/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseAgileField
 */
export interface DatabaseAgileField extends DatabaseField {
    /**
     * 
     * @type {string}
     * @memberof DatabaseAgileField
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAgileField
     */
    colorActive?: string;
}

/**
 * Check if a given object implements the DatabaseAgileField interface.
 */
export function instanceOfDatabaseAgileField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseAgileFieldFromJSON(json: any): DatabaseAgileField {
    return DatabaseAgileFieldFromJSONTyped(json, false);
}

export function DatabaseAgileFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseAgileField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'color': !exists(json, 'color') ? undefined : json['color'],
        'colorActive': !exists(json, 'colorActive') ? undefined : json['colorActive'],
    };
}

export function DatabaseAgileFieldToJSON(value?: DatabaseAgileField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'color': value.color,
        'colorActive': value.colorActive,
    };
}

